document.addEventListener('DOMContentLoaded', function() {
    const invitationBlocks = document.querySelectorAll('.invitation');

    invitationBlocks.forEach(block => {
        const invitationButtons = block.querySelectorAll('.invitation-btn');
        const commentField = block.querySelector('.invitation-comment-field');
        const commentTextarea = block.querySelector('.invitation-comment-textarea');
        const saveCommentBtn = block.querySelector('.invitation-save-comment-btn');
        const changeResponseBtn = block.querySelector('.invitation-change-response-btn');

        // Handle response button clicks
        if (invitationButtons.length > 0) {
            invitationButtons.forEach(button => {
                button.addEventListener('click', function(e) {
                    // mark button as selected
                    invitationButtons.forEach(btn => btn.classList.remove('selected'));
                    this.classList.add('selected');

                    // store reference to button for timeout function
                    const btnReference = this;

                    // handle the response after delay to show the selection
                    setTimeout(() => handleInvitationResponse(btnReference), 200);
                });
            });
        }

        // Handle save comment button
        if (saveCommentBtn && commentTextarea) {
            saveCommentBtn.addEventListener('click', function(e) {
                e.preventDefault();
                handleSaveComment(commentTextarea);
            });
        }

        // response change
        if (changeResponseBtn) {
            changeResponseBtn.addEventListener('click', function() {
                const responseContainer = this.closest('.invitation-user-response');
                const buttonContainer = block.querySelector('.invitation-response-buttons');

                if (buttonContainer) {
                    // Hide response
                    responseContainer.style.display = 'none';

                    // Show buttons
                    buttonContainer.style.display = 'flex';

                    //select button that matches current response
                    const currentResponse = responseContainer.querySelector('strong').innerText.toLowerCase();
                    if (currentResponse === 'ja') {
                        buttonContainer.querySelector('.invitation-yes-btn').classList.add('selected');
                    } else if (currentResponse === 'nei') {
                        buttonContainer.querySelector('.invitation-no-btn').classList.add('selected');
                    }
                }
            });
        }
    });

    function handleInvitationResponse(button) {
        // check if button or an event
        const targetButton = button.currentTarget ? button.currentTarget : button;
        const postId = targetButton.getAttribute('data-post-id');
        const invitationId = targetButton.getAttribute('data-invitation-id');
        const response = targetButton.getAttribute('data-response');
        const invitationBlock = targetButton.closest('.invitation');
        const commentField = invitationBlock.querySelector('.invitation-comment-field');
        const commentTextarea = invitationBlock.querySelector('.invitation-comment-textarea');

        console.log('Button:', targetButton);
        console.log('Post ID:', postId);
        console.log('Invitation ID:', invitationId);
        console.log('Response:', response);

        if (!postId || !response) {
            console.error('Missing data attributes for invitation response. Button:', targetButton);
            return;
        }

        // loading state
        const allButtons = targetButton.parentNode.querySelectorAll('button');
        allButtons.forEach(btn => {
            btn.disabled = true;
            btn.classList.add('processing');
        });

        // AJAX request
        const data = new FormData();
        data.append('action', 'invitation_response');
        data.append('post_id', postId);
        data.append('invitation_id', invitationId);
        data.append('response', response);
        data.append('security', feltpost_scripts.nonce); // nonce
        
        if (commentTextarea) {
            data.append('comment', commentTextarea.value);
        }
        data.append('security', feltpost_scripts.nonce);

        $.ajax({
            url: feltpost_scripts.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            processData: false,
            contentType: false,
            error: function(error) {
                console.error('Error submitting response', error);
                // re-enable buttons
                allButtons.forEach(btn => {
                    btn.disabled = false;
                    btn.classList.remove('processing');
                });
            },
            success: function(response) {
                if (!response.success) {
                    console.error('Error in response', response);
                    console.error('Error message:', response.data ? response.data.message : 'No message');
                    // Still re-enable buttons even on error
                    allButtons.forEach(btn => {
                        btn.disabled = false;
                        btn.classList.remove('processing');
                    });
                    return;
                }

                // Update button states based on response
                allButtons.forEach(btn => {
                    btn.disabled = false;
                    btn.classList.remove('processing');

                    // Set selected state based on server response
                    const buttonResponse = btn.getAttribute('data-response');
                    if (buttonResponse === response.data.response) {
                        btn.classList.add('selected');
                    } else {
                        btn.classList.remove('selected');
                    }
                });

                // Show comment field if it exists and user has responded
                console.log('Comment field:', commentField, 'Response:', response.data.response);
                if (commentField && response.data && response.data.response) {
                    console.log('Showing comment field');
                    commentField.style.display = 'block';
                }
            }
        });
    }

    function handleSaveComment(textarea) {
        const postId = textarea.getAttribute('data-post-id');
        const invitationId = textarea.getAttribute('data-invitation-id');
        const comment = textarea.value;
        const saveBtn = textarea.parentElement.querySelector('.invitation-save-comment-btn');

        if (!postId || !invitationId) {
            console.error('Missing data attributes for comment save');
            return;
        }

        // Loading state
        saveBtn.disabled = true;
        saveBtn.classList.add('processing');
        const originalText = saveBtn.textContent;
        saveBtn.textContent = 'Lagrer...';

        // AJAX request
        const data = new FormData();
        data.append('action', 'save_invitation_comment');
        data.append('post_id', postId);
        data.append('invitation_id', invitationId);
        data.append('comment', comment);
        data.append('security', feltpost_scripts.nonce);

        $.ajax({
            url: feltpost_scripts.ajax_url,
            type: 'POST',
            data: data,
            cache: false,
            processData: false,
            contentType: false,
            error: function(error) {
                console.error('Error saving comment', error);
                saveBtn.disabled = false;
                saveBtn.classList.remove('processing');
                saveBtn.textContent = originalText;
            },
            success: function(response) {
                saveBtn.disabled = false;
                saveBtn.classList.remove('processing');

                if (response.success) {
                    saveBtn.textContent = 'Lagret!';
                    setTimeout(() => {
                        saveBtn.textContent = originalText;
                    }, 2000);
                } else {
                    console.error('Error saving comment', response);
                    saveBtn.textContent = originalText;
                }
            }
        });
    }
});